module.exports = __webpack_public_path__ + "static/media/Rycoon.1a3d3b81.png";